export const EOverrideType = {
  FINAL: "final",
  NEEDS_INPUT: "needs_input",
  OVERRIDABLE: "overridable",
} as const;

export type EOverrideType = (typeof EOverrideType)[keyof typeof EOverrideType];

export const EOverrideTypeMembers = Object.values(EOverrideType);
